import MDBox from "../../../../components/MDBox";
import pxToRem from "../../../../assets/theme/functions/pxToRem";
import { useCallback, useEffect, useState} from "react";
import {useApi} from "../../../../services/helpers";
import MDTypography from "../../../../components/MDTypography";
import MDInput from "../../../../components/MDInput";
import AddBaseModal from "../../../../components/add-base-modal/AddBaseModal";
import {observer} from "mobx-react";
import {useApiMessages} from "../../../../services/api/api-messages";
import * as Yup from "yup";
import {FormikProvider, useFormik} from "formik";
import {useDebouncedValidate} from "../../../../shared/formik_debounce_validate";
import FormikInput from "../../../../components/FormikInput";
import trash from "assets/icons/trash.svg"

Yup.addMethod(Yup.array, "unique", function (message) {
  return this.test("unique", message, function (list) {
    const mapper = x => x.name;
    const set = [...new Set(list.map(mapper))];
    const isUnique = list.length === set.length;
    if (isUnique) {
      return true;
    }

    const idx = list.findIndex((l, i) => mapper(l) !== set[i]);
    return this.createError({
      path: `values[${idx}].name`,
      message: message,
    });
  });
});

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Option name is required'),
})

export const AddOptionValueModal = observer(({open, item, onClose, loading, onUpdate}) => {
  const api = useApi()
  const [values, setValues] = useState([])
  const [addValue, setAddValue] = useState(null)
  const valuesMessage = useApiMessages('option', 'options')

  const formik = useFormik({
    initialValues: {
      id: item?.id ? item.id : null,
      name: item?.id ? item.name : "",
    },
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => createOptions(values),
  })

  useDebouncedValidate({
    validate: values => {
      formik.validateForm(values);
    },
    debounceTime: 200,
    values: formik.values,
  });

  useEffect(() => {
    getAllOptions()
  }, [])

  const createOptions = () => {
    api.createOptions(item?.id, {name: addValue}).handle({
      onSuccess: ()=> getAllOptions(),
        errorMessage: valuesMessage.get.error,
      onFinally: () => {
        setAddValue('')
      }
      }
    )
  }

  const editOptionValue = (data) => {
    api.updateOptions(item?.id, data).handle({
      onSuccess: ()=> getAllOptions(),
        errorMessage: valuesMessage.update.error,
      }
    )
  }

  const getAllOptions = () => {
    api.getAllOptions(item?.id).handle({
        onSuccess: (result) => setValues(result?.data.results),
        errorMessage: valuesMessage.get.error,
      }
    )
  }

  const deleteOptions = (value_id) => {
    api.deleteOptions(item?.id, value_id).handle({
        successMessage: valuesMessage.delete.success,
        onSuccess: ()=> getAllOptions(),
        errorMessage: valuesMessage.delete.error,
      }
    )
  }

  return (
    <AddBaseModal
      open={open}
      handleClose={() => {
        formik.resetForm()
        onClose()
      }}
      title={item?.id ? "Edit Option" : "Add Option"}
      buttonText={"Save"}
      // onSubmit={formik.handleSubmit}
      loading={loading}
      showActions={false}
    >
      <MDBox
        display='flex'
        flexDirection='column'
        gap={pxToRem(22)}
        pt={pxToRem(32)}
        pb={pxToRem(32)}
        px={pxToRem(45)}
        maxHeight={pxToRem(600)}
        sx={{ overflow: 'auto' }}
      >
        <FormikProvider value={formik}>
          <FormikInput name="name" label="Option Name" disabled={true}/>
            {item && (
              <>
                <MDInput type={'text'} value={addValue} label="Value" onChange={(e) => setAddValue(e.target.value)}  />
                <MDTypography
                  variant="button"
                  color="info"
                  fontWeight="regular"
                  sx={{cursor: 'pointer'}}
                  textAlign="right"
                  onClick={createOptions}
                >
                  + Create Option value
                </MDTypography>
                {values?.length ? values?.map((value, indexFromMap) => (
                  <MDBox
                    key={`id-value-${indexFromMap}`}
                    display={'flex'}
                    width={'50%'}
                    justifyContent={'space-between'}
                    borderRadius={'xl'}
                    border={'1px solid grey'}
                    p={0.5}
                  >
                    <MDTypography
                      variant={'button'}
                      color={'tertiary'}
                      fontWeight="regular"
                    >
                      {value?.name}
                    </MDTypography>
                    <MDBox component={'img'} src={trash} onClick={() => deleteOptions(value.id)} />
                  </MDBox>
                )) : null}

              </>
            )}
        </FormikProvider>
      </MDBox>
    </AddBaseModal>
  )
})
